import {React, useEffect, useState} from 'react';
import jawlogo from '../../Images/jaw-logo.png';
import ranelogo from '../../Images/Rane.jpg';
import rane1 from '../../Images/rane-img-1.jpeg';
import rane2 from '../../Images/rane2.jpg';
import rane3 from '../../Images/rane3.jpg';
import rane4 from '../../Images/rane4.jpg';
import rane6 from '../../Images/rane6.jpg';
import rane7 from '../../Images/rane7.jpg';
import rane8 from '../../Images/rane8.jpg';
import rane9 from '../../Images/rane9.jpg';
import rane10 from '../../Images/rane10.jpg';
import { FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

// Placeholder images for the gallery and QR codes.
// Replace these with your actual image imports.
const galleryImages = [
 rane3,
 rane6,
 rane7,
 rane8,
 rane9,
 rane10,
];

const qrCodeHospet = 'https://via.placeholder.com/150';
const qrCodeChitradurga = 'https://via.placeholder.com/150';

const API_BASE_URL = (process.env.NODE_ENV === 'production' ? 'https://japl-backend-v2jm.onrender.com/api' : 'http://localhost:5000/api')
// const API_BASE_URL = 'http://localhost:5000/api'

const JAW_RANE = () => {
  
      // State for backend QR URLs for RANE sub-branches
  const [qrHospet, setQrHospet] = useState(null);
  const [qrChitradurga, setQrChitradurga] = useState(null);

  // Fetch QR for RANE Hospet and Chitradurga on mount
  useEffect(() => {
    async function fetchQRs() {
      try {
        const res1 = await fetch(`${API_BASE_URL}/branchqrcode/Rane::Hospet`);
        if (res1.ok) {
          const data1 = await res1.json();
            setQrHospet(data1.qrCodeImageURL.startsWith('http') ? data1.qrCodeImageURL : `https://japl-backend-v2jm.onrender.com/${data1.qrCodeImageURL.replace(/^\//, '')}`);
        } else {
          setQrHospet(null);
        }

        const res2 = await fetch(`${API_BASE_URL}/branchqrcode/Rane::Chitradurga`);
        if (res2.ok) {
          const data2 = await res2.json();
            setQrChitradurga(data2.qrCodeImageURL.startsWith('http') ? data2.qrCodeImageURL : `https://japl-backend-v2jm.onrender.com/${data2.qrCodeImageURL.replace(/^\//, '')}`);
        } else {
          setQrChitradurga(null);
        }
      } catch {
        setQrHospet(null);
        setQrChitradurga(null);
      }
    }
    fetchQRs();
  }, []);



  return (
    <div className=''>
      {/* Hero Section */}
    <section className="relative h-[390px] md:h-[370px] lg:h-[400px] w-full flex items-center justify-center overflow-hidden">
        {/* Background image */}
        <img
          src={rane6}
          alt="Engine Workshop Background"
          className="absolute inset-0 w-full h-[390px] md:h-[370px] lg:h-[400px] object-cover object-center"
          style={{ zIndex: 1 }}
        />
        {/* Backdrop overlay for readability */}
        <div
          className="absolute inset-0 h-[390px] md:h-[370px] lg:h-[400px] bg-black/30"
          style={{ zIndex: 2 }}
        />
    
        {/* Content Row */}
        <div className="relative z-10 flex flex-col items-center justify-center w-full max-w-6xl px-6 pt-4">
          {/* Logo */}
          <div className="flex flex-col items-center justify-center text-white w-full">
            <img
              src={jawlogo}
              alt="JAW Logo"
              className="w-20 h-20 object-cover drop-shadow-xl rounded-full mx-auto sm:mx-0"
            />
          </div>
    
          {/* Headings */}
          <h1 className="text-white text-3xl md:text-5xl font-bold tracking-tight leading-tight text-center drop-shadow-lg mt-4">
            JANATHA AUTO WORKS
          </h1>
          <div className="bg-blue-500 p-2 text-center rounded-xl mt-4 text-lg md:text-xl font-semibold text-white drop-shadow-sm max-w-full">
            ZF RANE AUTHORISED SERVICE CENTER
          </div>
        </div>
      </section>
      
      {/* Description Section */}
      <div className='pt-12 mx-auto px-4 sm:px-8 md:px-12 lg:px-20'>
        <div className='flex flex-col md:flex-row items-center justify-center gap-4 text-center md:text-left'>
          <img src={ranelogo} alt="rane-logo" className='h-16 md:h-24' />
          <h2 className='text-2xl md:text-4xl lg:text-5xl font-bold text-gray-900 font-sans mt-4 md:mt-0'>Expert Power Steering Solutions</h2>
        </div>
        <p className='px-4 md:px-20 text-center text-sm md:text-lg lg:text-xl pt-4 text-gray-700'>
          As ZF Rane's authorized service partner, we deliver certified power steering solutions with genuine components and factory-trained expertise. Our support ensures optimal vehicle performance for commercial and industrial applications.
        </p>
      </div>

      {/* 3-Cards Section */}
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mx-4 sm:mx-8 md:mx-12 lg:mx-20 py-12'>
        {/* Card 1 */}
        <div className='border border-gray-200 p-4 rounded-xl shadow-lg'>
          <img src={rane1} alt="rane image" className='w-full h-48 md:h-64 object-cover rounded-xl' />
          <h3 className='text-lg md:text-xl font-semibold text-center py-4 '>Factory-Trained Technical Team</h3>
          <p className='text-center text-sm md:text-base text-gray-500'>Regularly trained and certified by ZF RANE experts for precision maintenance and repairs.</p>
        </div>

        {/* Card 2 */}
        <div className='border border-gray-200 p-4 rounded-xl shadow-lg'>
          <img src={rane2} alt="rane image" className='w-full h-48 md:h-64 object-cover rounded-xl' />
          <h3 className='text-lg md:text-xl font-semibold text-center py-4'>Inventory – Always Ready</h3>
          <p className='text-center text-sm md:text-base text-gray-500'>Immediate parts availability for faster turnaround and minimized downtime.</p>
        </div>

        {/* Card 3 */}
        <div className='border border-gray-200 p-4 rounded-xl shadow-lg'>
          <img src={rane3} alt="rane image" className='w-full h-48 md:h-64 object-cover rounded-xl' />
          <h3 className='text-lg md:text-xl font-semibold text-center py-4'>Comprehensive Services</h3>
          <p className='text-center text-sm md:text-base text-gray-500'>Full range of power steering system services with OEM standards.</p>
        </div>
      </div>

      {/* Commitment Section */}
      <div className='grid grid-cols-1 md:grid-cols-2 p-8 gap-6 mx-4 sm:mx-8 md:mx-12 lg:mx-20 shadow-2xl rounded-lg bg-gray-50'>
        <div className='space-y-4'>
          <h3 className='text-2xl md:text-3xl font-semibold text-gray-800'>OUR COMMITMENT</h3>
          <ul className='space-y-2 text-sm md:text-base text-gray-600'>
            <li>• Genuine ZF Rane parts with warranty</li>
            <li>• Advanced diagnostic capabilities</li>
            <li>• Reliable Customer Support</li>
            <li>• OEM-standard repair protocols</li>
            <li>• Factory-trained technicians</li>
          </ul>
        </div>
        <div>
          <img src={rane4} alt="rane-4" className='w-full h-48 md:h-72 object-cover rounded-xl' />
        </div>
      </div>
      
      {/* Gallery Section */}
      <div className='py-12 mx-4 sm:mx-8 md:mx-12 lg:mx-20 pt-12'>
        <h2 className='text-3xl md:text-4xl font-bold text-center mb-8 text-gray-900'>Gallery</h2>
        <div className='grid grid-cols-2 md:grid-cols-3  gap-4'>
          {galleryImages.map((image, index) => (
            <div key={index} className='overflow-hidden rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105'>
              <img src={image} alt={`Gallery image ${index + 1}`} className='w-full h-40 md:h-52 object-cover' />
            </div>
          ))}
        </div>
      </div>

      {/* Contact/Footer Section as per image */}
      <div className='py-12 bg-gray-900 text-white text-center px-4 sm:px-8 md:px-12 lg:px-20'>
        <div className='max-w-4xl mx-auto'>
          <h2 className='text-2xl md:text-3xl lg:text-4xl font-bold pt-4 font-sans mb-2 text-cyan-400'>EXPERT STEERING SYSTEM SUPPORT</h2>
          <p className='text-sm md:text-base text-gray-300 mb-8'>
            Need professional power steering service or genuine ZF Rane parts? Our certified technicians are ready to assist.
          </p>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
          {/* Card 1: Contact Information */}
          <div className='bg-gray-800 p-6 rounded-lg shadow-lg'>
            <h3 className='text-xl font-bold mb-4'>CONTACT INFORMATION</h3>
            <div className='space-y-4 text-left'>
              <div>
                <p className='text-sm font-semibold mb-1 text-blue-300'>Hospet</p>
                <div className='flex items-center space-x-2 text-gray-400'>
                  <FaPhoneAlt className='text-blue-400' />
                  <span>88840 13007</span>
                </div>
                <div className='flex items-center space-x-2 text-gray-400 mt-1'>
                  <FaEnvelope className='text-blue-400' />
                  <span>jaw.hpt@gmail.com</span>
                </div>
              </div>
              <hr className='border-gray-700' />
              <div>
                <p className='text-sm font-semibold mb-1 text-blue-300'>Chitradurga</p>
                <div className='flex items-center space-x-2 text-gray-400'>
                  <FaPhoneAlt className='text-blue-400' />
                  <span>9742153614</span>
                </div>
                <div className='flex items-center space-x-2 text-gray-400 mt-1'>
                  <FaEnvelope className='text-blue-400' />
                  <span>jaw.durga@gmail.com</span>
                </div>
              </div>
            </div>
          </div>

          {/* Card 2: Hospet Address */}
          <div className='bg-gradient-to-br from-blue-900/50 to-cyan-800/50 p-6 rounded-lg shadow-lg flex flex-col items-center justify-center'>
            <h3 className='text-xl font-bold mb-4'>HOSPET ADDRESS</h3>
            <p className='text-sm text-gray-400 mb-4'>Scan for directions</p>
            <img
              src={qrHospet || qrCodeHospet}
              alt="QR Code Hospet"
              className='w-40 h-40 rounded-lg bg-white'
            />
            <p className='mt-4 text-sm text-gray-400'>Janatha Auto Works - Near RTO Office, Harihar Road</p>
          </div>

          {/* Card 3: Chitradurga Address */}
          <div className='bg-gradient-to-br from-blue-900/50 to-cyan-800/50 p-6 rounded-lg shadow-lg flex flex-col items-center justify-center'>
            <h3 className='text-xl font-bold mb-4'>CHITRADURGA ADDRESS</h3>
            <p className='text-sm text-gray-400 mb-4'>Scan for directions</p>
           <img
              src={qrChitradurga || qrCodeChitradurga}
              alt="QR Code Chitradurga"
              className='w-40 h-40 rounded-lg bg-white'
            />
            <p className='mt-4 text-sm text-gray-400'>Janatha Auto Works - Oppo Bapuji High School, NH-13 Road</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JAW_RANE;